import React from 'react';
import { Radio, Flex } from 'antd';

interface Props {
	styles?: React.CSSProperties;
	handleClick: (value: any) => void;
	cut_status: string;
	/** When true, Not Cut is not selectable (recorded cuts would conflict with API rules). */
	disableNotCut?: boolean;
}

const CutActions = (props: Props) => {
	const { cut_status, styles } = props;

	const baseButtonStyle: React.CSSProperties = {
		whiteSpace: 'nowrap',
		fontSize: 16,
		height: 'auto',
		lineHeight: 2,
		padding: '6px 24px',
	};
	const selectedStyle: React.CSSProperties = {
		...baseButtonStyle,
		borderWidth: '2px',
		fontWeight: 'bold',
	};

	return (
		<Radio.Group
			style={{ display: 'flex', flexDirection: 'column', ...styles }}
			size="large"
			onChange={async (event) => {
				props.handleClick(event.target.value);
			}}
			value={props.cut_status}
			optionType="button"
		>
			{cut_status !== 'Cut' ? (
				<Radio.Button
					value={'Not Cut'}
					disabled={Boolean(props.disableNotCut)}
					style={cut_status === 'Not Cut' ? selectedStyle : baseButtonStyle}
				>
					Not Cut
				</Radio.Button>
			) : null}

			{cut_status !== 'Cut' ? (
				<Radio.Button
					value={'In Progress'}
					style={cut_status === 'In Progress' ? selectedStyle : baseButtonStyle}
				>
					In Progress
				</Radio.Button>
			) : null}

			<Radio.Button
				value={'Cut'}
				disabled={cut_status == 'Cut'}
				style={cut_status === 'Cut' ? selectedStyle : baseButtonStyle}
			>
				Cut
			</Radio.Button>
		</Radio.Group>
	);
};

export default CutActions;
